<script lang="ts" setup>
import { buildMeta } from "~~/utils/meta-builder";

useHead(buildMeta({
	key:'for-work', 
	follow: true
}))
	
</script>

<template>
	
	<div class="overflow-x-hidden">
		<Header theme="light" />
		<div class="md:max-w-screen-xl mx-auto px-2 md:px-0 ">

			<!-- Header -->

			<div class="relative mb-10 pb-2 flex flex-col lg:flex-row lg:items-center">
				<div class="flex-1 px-10 pb-10 ">
					<h2 class="text-5xl font-owners font-bold text-dark-900" v-html="$t('for-work.headline')"></h2>
					<p class="text-lg pt-4 pb-12 pr-8 font-light max-w-2xl" v-html="$t('for-work.body')"></p>
					<a href="#subscribe" class="btn-primary rounded-full">{{$t('for-work.action')}}</a>
				</div>
				<div class="flex-1 flex flex-row items-start gap-4 lg:pt-0 bg-slate-100 p-10 rounded-2xl">
				
					<nuxt-img 
						provider="cloudinary"
						src="/app_screen_home_with_device.png" height="500" loading="lazy" alt="device smoxy app home screen" 
						class="drop-shadow-xl rounded-2x pt-4" />   
						
					<nuxt-img 
						provider="cloudinary"
						src="/portal-2.png" height="500" loading="lazy" alt="device smoxy for work portal dashboard web" 
						class="drop-shadow-xl rounded-2x pt-4" />   
							
				</div>
			</div>

			<!-- Features -->

			<div class="relative gap-x-6 gap-y-12 py-10 px-10 flex flex-col lg:flex-row lg:items-center">
				<div class="flex-1">
					<h3 class="text-2xl" v-html="$t('for-work.why.title')"></h3>
					<p class="text-sm pt-6 max-w-lg">{{$t('for-work.why.body')}}</p>
				</div>
				<div class="flex-1">
					<h3 class="text-2xl" v-html="$t('for-work.benefit.title')"></h3>
					<p class="text-sm pt-6 max-w-lg">{{$t('for-work.benefit.body')}}</p>
				</div>
			</div>

			<!-- Subscribe -->

			<div class="relative pb-8 md:pb-2 flex flex-col-reverse lg:flex-row items-center text-white bg-primary-500 rounded-2xl">

				<div class="flex-1 z-50 pb-16 pt-12 -mt-4" id="subscribe">
					<SubscribeForm class="ml-0 md:ml-10"  />

				</div>

				<div class="relative mx-auto flex justify-center flex-1">

					<!-- Progress BG -->
					<div x-data="scrollProgress" class="absolute top-5 md:-top-10 xl:top-5 p-10 h-full z-10">

						<svg width="568" height="568" viewBox="0 0 568 568" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M568 284C568 440.849 440.849 568 284 568C127.151 568 0 440.849 0 284C0 127.151 127.151 0 284 0C440.849 0 568 127.151 568 284ZM69.6198 284C69.6198 402.399 165.601 498.38 284 498.38C402.399 498.38 498.38 402.399 498.38 284C498.38 165.601 402.399 69.6198 284 69.6198C165.601 69.6198 69.6198 165.601 69.6198 284Z"
								fill="url(#paint0_linear_15950_110116)" fill-opacity="0.18" />
							<path
								d="M284 34.8099C284 15.5849 299.644 -0.220159 318.724 2.13032C372.105 8.70607 422.783 30.3476 464.651 64.8625C506.519 99.3773 537.431 144.996 554.069 196.142C560.016 214.424 547.486 232.795 528.614 236.463V236.463C509.742 240.13 491.734 227.65 485.064 209.619C471.991 174.282 449.754 142.809 420.366 118.582C390.978 94.3553 355.84 78.531 318.658 72.4396C299.686 69.3314 284 54.0349 284 34.8099V34.8099Z"
								fill="white" />
							<defs>
								<linearGradient id="paint0_linear_15950_110116" x1="284" y1="0" x2="284" y2="568"
									gradientUnits="userSpaceOnUse">
									<stop offset="0.348181" />
									<stop offset="0.794404" stop-opacity="0" />
								</linearGradient>
							</defs>
						</svg>


					</div>

					<!-- Boy -->
					<nuxt-img src="boy-device.png" alt="smoxy for work teaser image" class="-mt-5 w-full h-full max-w-xl z-40" />


				</div>
			</div>

			
			<!-- How it works -->
			<div class="rounded-2xl p-0 pt-10 md:p-10 mt-6 bg-slate-50">
				<h3 class="pt-2 pb-12 font-bold font-owners text-3xl text-center">{{$t('for-work.how_to.title')}}</h3>
				<div class="grid grid-rows-3 md:grid-cols-3 px-4 md:px-10">
					<div class="flex-1 pt-4 md:pt-0">
						<p class="font-bold w-16 flex items-center justify-center text-center aspect-square rounded-full border border-slate-200 text-dark-900 font-owners text-xl">01</p>
						<p class="text-lg pt-4 pl-5">{{$t('for-work.how_to.one')}}</p>
					</div>
					<div class="flex-1 pt-6 md:pt-0">
						<p class="font-bold w-16 flex items-center justify-center text-center aspect-square rounded-full border border-slate-200 text-dark-900 font-owners text-xl">02</p>
						<p class="text-lg pt-4 pl-5">{{$t('for-work.how_to.two')}}</p>
					</div>
					<div class="flex-1 pt-4 md:pt-0">
						<p class="font-bold w-16 flex items-center justify-center text-center aspect-square rounded-full border border-slate-200 text-dark-900 font-owners text-xl">03</p>
						<p class="text-lg pt-4 pl-5">{{$t('for-work.how_to.three')}}</p>
					</div>
				</div>
			</div>
		

			
			
			<!-- <div class="px-20 py-20 max-w-xl mx-auto">
				<h3 class="pb-10 font-bold font-owners text-xl">So funktioniert’s</h3>
				<ol class="relative border-l border-primary-500">                  
					<li class="mb-10 ml-6">            
							<span class="flex absolute -left-3 justify-center items-center w-6 h-6 bg-primary-500 rounded-full ring-8 ring-primary-500/20 text-white">
							
							</span>
							
							<p class="mb-4 ml-4 text-base font-normal text-gray-500">Unternehmen registrieren und Programm konfigurieren</p>
					</li>
					<li class="mb-10 ml-6">
						<span class="flex absolute -left-2 justify-center items-center w-4 h-4 bg-primary-500 rounded-full text-white">
							
							</span>
							
							<p class="mb-4 ml-4 text-base font-normal text-gray-500">Kostenlose Informationskampagne mit Bedarfsanalyse</p>
					</li>
					<li class="mb-10 ml-6">
						<span class="flex absolute -left-2 justify-center items-center w-4 h-4 bg-primary-500 rounded-full text-white">
							
							</span>
							
							<p class="mb-4 ml-4 text-base font-normal text-gray-500">Unverbindliches Angebot erhalten</p>
					</li>
				
			</ol>
			</div>	 -->


		</div>
	
		<Footer />
	</div>
</template>